import * as React from 'react';

interface Props {
	isLoading: boolean;
	children: React.ReactNode;
	height: number | null;
}

const Loading = ({ isLoading, children, height }: Props) => {
	if (isLoading) {
		const heightStyle = null !== height ? height : undefined;

		return (
			<div className="rc-loading" style={{ height: heightStyle }}>
				<div className="rc-loading__spinner" />
			</div>
		);
	}
	return <>{children}</>;
};

export default Loading;
